import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const postesSlice = createSlice({
    name: 'postes',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {
        resetDetailsPostes: (state) => {    
            if (state.detailsPostes == null) {
                state.detailsPostes = ''
            } else {
                state.detailsPostes = null
            }
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsPostes.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsPostes.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.detailsPostes = action.payload
        })
        .addCase(fetchDetailsPostes.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchPostes.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchPostes.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchPostes.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createPoste.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createPoste.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createPoste.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deletePoste.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deletePoste.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deletePoste.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchPostes = createAsyncThunk(
    'postes/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/rh.poste.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch postes')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsPostes = createAsyncThunk(
    'Postes/fetchDetails',
    async (id) => {
        const data = {'id':id.id}
        try {
            const Poste = await BaseService.post(
                `/XML/rh.poste.load/get_employe_poste`,data
            )


            const detailsPoste = await BaseService.post(
                `/XML/rh.poste.load/get_one_post`,data
            )
           

            return {Poste:Poste.data,detailsPoste:detailsPoste.data}
        } catch (error) {
            throw new Error('Failed to fetch Postes')
        }
    }
)
export const createPoste = createAsyncThunk(
    'postes/post',
    async (payload) => {
        const { data, formik, navigate,setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/rh.poste.send/ajouter', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editPoste = createAsyncThunk('postes/edit',  async (payload) => {
    const { data, formik, navigate,setClientAdded } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.post('/XML/rh.poste.send/modifier', data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(creation?.success)
            setClientAdded(true)
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(creation?.error)
    }
})

export const deletePoste = createAsyncThunk(
    'poste/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/postes/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.postes.data
export const selectIsLoading = (state) => state.postes.isLoading
export const selectError = (state) => state.postes.error
export const selectIsDeleted = (state) => state.postes.isDeleted
export const selectCurrentPage = (state) => state.postes.currentPage
export const resetDetailsPostes = postesSlice.actions.resetDetailsPostes
export default postesSlice.reducer
